import {
  createSimpleTablePageSlice,
  createSimpleTablePageSelector,
} from "./common";

export const caseRecordSlice = createSimpleTablePageSlice("caseRecord");

export const selectCaseRecordState = createSimpleTablePageSelector("caseRecord");

export const { setQueryParams } = caseRecordSlice.actions;

export default caseRecordSlice.reducer;
